/** @format */

import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output,
	ViewChild
} from '@angular/core';
import { MediaSourceEnum, ObjectFitEnum } from '../models';
import { ReviewMedia, ReviewSelectedMedia } from '@product-reviews/data-access';
import { Subject, map, takeUntil } from 'rxjs';

import { KillswitchService, UtilityService } from '@shared/data-access/services';

import { chain } from '@core/chain';

@Component({
	selector: 'product-reviews-review-media',
	templateUrl: './review-media.component.html',
	styleUrl: './review-media.component.scss',
	standalone: false
})
export class ReviewMediaComponent implements OnInit, OnDestroy {
	@Input() imageId = 0;
	@Input() media: ReviewMedia;
	@Input() showVideo = false;
	@Input() objectFit = ObjectFitEnum.COVER;
	@Input() mediaSource = MediaSourceEnum.CAROUSEL;
	@Output() selectedMedia = new EventEmitter<ReviewSelectedMedia>();
	@ViewChild('element') element: HTMLImageElement;
	hasNewReviewsEnhancement = false;
	mediaSourceClasses: string[] = [];
	mediaSourceContainerClass = '';

	private UNSUBSCRIBE$ = new Subject<void>();

	constructor(
		private utilityService: UtilityService,
		private killSwitchService: KillswitchService
	) {}

	ngOnInit(): void {
		this.killSwitchService
			.getKillSwitchesEnvironment$()
			.pipe(
				takeUntil(this.UNSUBSCRIBE$),
				map((data) =>
					this.utilityService.checkKillSwitch(
						'newReviewsEnhancement',
						data,
						chain.chainIdentifierAbbr
					)
				)
			)
			.subscribe((hasNewReviewsEnhancement) => {
				this.hasNewReviewsEnhancement = hasNewReviewsEnhancement;
				this.mediaSourceClasses = this.buildMediaSouceClasses();
			});
	}

	ngOnDestroy(): void {
		this.UNSUBSCRIBE$.next();
		this.UNSUBSCRIBE$.complete();
	}

	handleMedia(): void {
		const selectedMedia = {
			...this.media,
			imageId: this.imageId
		};
		this.selectedMedia.emit(selectedMedia);
	}

	private buildMediaSouceClasses(): string[] {
		const classNames: string[] = [];
		if (this.media) {
			classNames.push(
				this.objectFit === ObjectFitEnum.COVER ? 'object-fit-cover' : 'object-fit-contain'
			);

			if (this.mediaSource === MediaSourceEnum.CAROUSEL_STATIC) {
				classNames.push('source-carousel', 'source-static');
			} else if (this.mediaSource === MediaSourceEnum.CAROUSEL) {
				classNames.push('source-carousel');
			} else if (this.mediaSource === MediaSourceEnum.DRAWER) {
				classNames.push('source-drawer');
			} else if (
				this.hasNewReviewsEnhancement &&
				this.mediaSource === MediaSourceEnum.SECTION
			) {
				classNames.push('source-section');
				this.mediaSourceContainerClass = 'hmf-display-flex hmf-align-items-center';
			}
			return classNames;
		}
	}
}
